import BaseOnboardingService from "./baseOnboarding.service";

class UnavailabilityGravityService extends BaseOnboardingService {
  constructor() {
    super("unavailability-gravity");
  }
}

export default new UnavailabilityGravityService();